/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  company.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/3/21 11:05
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { axiosAPIUrl, Parameter,assignParams } from './index'

// 公司信息
export class companyMsgOTD {
  companyId?: string // 公司编号

  companyName?: string // 公司名称

  industryId?: string // 行业

  industryName?: string // 行业名称

  inviteCode?: string // 邀请码

  addressName?: string // 公司地址

  addressId?: string // 公司地址ID

  addressDtl?: string // 公司地址明细

  legalPerson?: string // 法人

  companyInfo?: string // 公司简介

  isCertification?: string // '是否企业认证

  logoUrl?: string // 公司logo
  imageBase64Url?: string

  companyEmail?: string // 邮箱

  companyWebsite?: string // 公司网站

  taxpayerNo?: string // 纳税人编号

  invoiceHeader?: string // 发票抬头

  serviceLineList?: Array<serviceLineListOTD>

  accountList?: Array<accountListOTD>

  addressList!: Array<addressListOTD>
}

// 服务热线
export class serviceLineListOTD {
  lineName?: string // 热线名称
  linePhone?: string // 热线方式
}

// 收货地址
export class addressListOTD {
  autoId?: string // 自动编号
  addressName?: string // 收货地址
  addressId?: string // 收货地址ID
  addressDtl?: string // 收货地址明细
  isDefault?: string // 是否默认收货地址
  receiveMobile!: string // 收货人电话
  receiveMan?: string // 收货人
}

// 银行信息
export class accountListOTD {
  accountName?: string // 账户名称',
  accountBank?: string // 开户银行',
  accountId!: string // 银行卡号'
  accountShow?: boolean // 开户银行弹框是否弹出
}

export class addrOTD {
  addressFullName?: string // 区域名全称
  addressId?: string // 区域ID
  addressName?: string // 当前区域名
  createTime?: string // 创建时间
  createUser?: string // 创建人
  parentId?: string // 上一级
  updateTime?: string // 更新时间
  updateUser?: string // 更新人
  value?: string //  区域ID
  label?: string //  当前区域名
  isLeaf?: boolean //  是否是最后一级
  children?: Array<addrOTD>
  loading?: boolean // 请求状态
}

export class AddressDTO {
  addressId?: string
  addressName?: string
  level?: string
}

export class partnerCompanyDto {
  companyShortName?: string // 合作方公司简称
  partnerCompanyid?: string // 	合作方公司id
  versionCode?: string // 	邀请码
  logo?: string // 合作方logo

}

/**
 * 获取公司详情
 * @param params
 */
export function GetCompanyDtl (params: Parameter) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/companyQuery/getCompanyDtl',
    method: 'post',
    data: {...params, ...assignParams()},
    extraParams: { showLoading: false }
  })
}

/**
 * 更新公司详情
 * @param params
 */
export function ModifyCompanyBase (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyManage/modifyCompanyBase',
    method: 'post',
    data: {...params, ...assignParams()}
  })
}

/**
 * 获取公司地址
 * @param params
 */
export function GetAddress (params: Parameter) {
  return axiosAPIUrl<Ajax.Response>({
    url: '/cykjoperation/companyManage/getAddress',
    method: 'get',
    params
  })
}

/**
 * 获取公司账卡信息
 * @param params
 */
export function getBankListInfo (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyQuery/getBankListInfo',
    method: 'get',
    params: {}
  })
}

/**
 * 获取版本列表
 * @param params
 */
export function getVersionCodeList (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/versionCode/getVersionCodeList',
    method: 'get',
    params:{...params, ...assignParams()}
  })
}

/**
 * 6.4 切换版本
 * @param params
 */
export function modifyBindingVersionCode (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/versionCode/modifyBindingVersionCode',
    method: 'post',
    data: {...params, ...assignParams()}
  })
}


/**
 * 6.1 邀请码匹配
 * @param params
 */
export function getCompareCode (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/versionCode/getCompareCode',
    method: 'get',
    params: params
  })
}


/**
 * 6.2 绑定邀请码
 * @param params
 */
export function bindingVersionCode (params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/versionCode/bindingVersionCode',
    method: 'post',
    data: {...params, ...assignParams()}
  })
}

// 2.12 获取合作方公司信息
export function getCompanyInfoByPartner (params?: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyQuery/getCompanyInfoByPartner',
    method: 'POST',
    data: { ...params }
  })
}

// 2.13 获取合作方公司信息
export function getPartnerCompanyList (params?: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjoperation/companyQuery/getPartnerCompanyList',
    method: 'POST',
    data: { ...params },
    extraParams: { showLoading: false }
  })
}
